import SlimSelect from 'slim-select'

// Register Slim Select on all select elements with class "multi-select"
function registerSlimSelect(): void {
  const selects = document.querySelectorAll('select.multi-select')
  selects.forEach(element => {
    new SlimSelect({
      select: element,
      settings: {
        showSearch: false,
        closeOnSelect: false
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  registerSlimSelect()
});
